<template>
  <div>
    <b-container>
      <b-row class="justify-content-center">
        <b-col lg="10">
          <b-row>
            <!-- <b-col sm="4">
              <b-img :src="require('../assets/alon.jpg')" fluid rounded class="w-100 shadow mb-4 mb-lg-0" />
            </b-col> -->

            <b-col>
              <h1>About</h1>
              <h2>Alon Shur</h2>

              <p>I am a New York based web developer and IT consultant with over a decade of professional experience as an IT Director leading a team of developers, designers, and project managers. I partner with agencies and individuals to provide professional technology services including many small to large companies such as Intuit, Logitech, Nikon, Schick and more.</p>

              <p>I build custom WordPress themes, custom Shopify themes for online E-Commerce stores, and custom web apps.</p>

              <p>Although I've been enthralled in the IT world throughout my professional career, I studied Graphic Design in college. This educational background has and continues to help me ensure seamless translation of a design vision to code above and beyond expectations.</p>

              <b-button variant="primary" size="lg" href="mailto: alon@alonshur.com" target="_blank">
                <font-awesome-icon icon="envelope" class="mr-2" /> Email Me
              </b-button>

              <b-button variant="primary" size="lg" href="https://www.linkedin.com/in/alonshur/" target="_blank" class="ml-2">
                <font-awesome-icon :icon="['fab', 'linkedin']" class="mr-2" /> LinkedIn
              </b-button>
            </b-col>
          </b-row>

          <hr class="my-4 my-lg-5">
          
          <b-row class="justify-content-center">
            <b-col>
              <h2>Clients</h2>
              <p>Throughout the years, I've had the opportunity to provide development and IT consultation services for many organizations including those listed below.</p>

              <b-row class="justify-content-center align-items-center my-lg-n3">
                <b-col v-for="client in clients" cols="4" lg="2" class="p-4" :key="client">
                  <b-img fluid class="w-100 mb-4 mb-lg-0" :alt="client"
                    :src="require('../assets/logos/logo-' + client.replace(/\s+/g, '-').toLowerCase() + '.png')"
                    :srcset="require('../assets/logos/logo-' + client.replace(/\s+/g, '-').toLowerCase() + '@2x.png') + ' 2x'" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      titleTemplate: 'About | %s',
    },

    data () {
      return {
        clients: [
          'Allstate',
          'ADT',
          'Culturelle',
          'Dynacraft',
          'GUESS',
          'Hermes',
          'Humanscale',
          'Intuit',
          'Kate Spade',
          'Kosher.com',
          'LG',
          'Logitech',
          'Nikon',
          'SAP',
          'Schick',
          'SyFy',
          'Vonage',
          'Zeiss'
        ]
      }
    }
  }
</script>
